<template>
  <v-dialog v-model="dialog" app fullscreen>
    <template v-if="selectedReportComp">
      <v-card tile color="white">
        <v-toolbar dark color="primary">
          <v-col cols="12" md="4" lg="3">
            <v-select
              v-model="selectedReportComp"
              return-object
              :items="reportsDropdown"
              filled
              class="report-selection"
              item-value="id"
              item-text="name"
              append-icon="$iconCaretDown"
              hide-details
              :menu-props="{
                nudgeBottom: '56px'
              }"
            />
          </v-col>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon dark @click="dialog = false">
              <v-icon>$iconTimes</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <template v-if="selectedReportComp.contentDeliveryType === 'IFRAME'">
          <h1 class="text-center pa-10 display-1">
            {{ $t("common:loading.messsage", "Loading...", "Loading message") }}
          </h1>
          <div>
            <iframe id="reports" :src="selectedReportComp.url" allowfullscreen>
            </iframe>
          </div>
        </template>
        <template v-else>
          <div class="text-center pa-10">
            <p>
              {{ selectedReportComp.description }}
            </p>
            <br />
            <v-btn
              rounded
              depressed
              large
              color="accent"
              :href="
                ['LINK', 'FILE'].includes(
                  selectedReportComp.contentDeliveryType
                )
                  ? selectedReportComp.contentDeliveryType == 'LINK'
                    ? selectedReportComp.url
                    : selectedReport.generatedReportFilePath
                  : undefined
              "
              target="_blank"
            >
              <template v-if="selectedReportComp.contentDeliveryType == 'FILE'">
                <v-icon small class="mr-2"> $iconDownload </v-icon>
                {{ $t("common:download.button") }}
              </template>
              <template
                v-else-if="selectedReportComp.contentDeliveryType == 'LINK'"
              >
                <v-icon small class="mr-2"> $iconArrowOutSquare </v-icon>
                {{ $t("common:navigate.button") }}
              </template>
            </v-btn>
          </div>
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import gql from "fraql";
export default {
  name: "ReportViewerDialog",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    selectedReport: {
      type: Object,
      default: null
    },
    reportsDropdown: {
      type: Array,
      required: true
    }
  },
  computed: {
    selectedReportComp: {
      get() {
        return this.selectedReport;
      },
      set(v) {
        this.$emit("update:selectedReport", v);
      }
    },
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  fragments: {
    reports: gql`
      fragment _ on Report {
        id
        name
        nameTranslations {
          locale
          value
        }
        description
        descriptionTranslations {
          locale
          value
        }
        contentDeliveryType
        generatedReportFilePath
        url
      }
    `
  }
};
</script>
<style scoped lang="scss">
iframe {
  position: fixed;
  top: 64px;
  bottom: 0px;
  right: 0px;
  width: 100%;
  border: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 999999;
  height: calc(100% - 64px);
}
</style>
